module.exports = __webpack_public_path__ + "static/media/sp30.986bcd54.JPG";